export default __webpack_public_path__ + "static/media/CryptoAdsNftAdLordpaperV1.5b80a2e0.pdf";